// extracted by mini-css-extract-plugin
module.exports = {"pageName":"Home_pageName__13Fsw","homeMain":"Home_homeMain__1Y-cG","description":"Home_description__3Fm-y","container":"Home_container__10N7u","highlight":"Home_highlight__1bI0Y"};